import { Typography } from 'components/Typography'
import { TooltipEstimatedDebtCost } from '../Tooltips'
import AchieveLogo from 'components/Svgs/AchieveLogo'

export const DtiTable = ({
  titleText,
  firstColumnLabel,
  lastColumnLabel,
  labelFirstRow,
  monthlyCurrent,
  monthlyAchieve,
  monthlySavings,
  totalCurrent,
  totalAchieve,
}) => {
  return (
    <div
      className="max-w-[500px] max-h-[200px] bg-[#F5F9FF] rounded-[8px] mt-8 mx-auto"
      data-testid="dti-table"
    >
      <div className="text-center mb-4" data-testid="dti-table-title">
        <Typography
          className="text-[#3B6AF7]"
          variant="labelSm"
          data-testid="dti-table-title-highlight"
        >
          {'You could save ' + monthlySavings + '/mo'}
        </Typography>
        <Typography variant="labelSm" data-testid="dti-table-title-text">
          {titleText}
          <sup>1</sup>
        </Typography>
      </div>
      <div className="flex justify-center items-center pb-6" data-testid="dti-table-grid">
        <table className="border-collapse w-full">
          <tbody>
            <tr className="flex flex-row w-full text-center" data-testid="title-row">
              <th className="flex flex-col basis-1/3 flex-1 h-10 p-0" aria-hidden="true" />
              <td className="flex items-center justify-center content-center flex-col basis-1/3 flex-1 h-10 p-0">
                <div className="flex items-center justify-center content-center">
                  <Typography
                    className="text-[#5C708A] leading-none"
                    variant="bodySm"
                    fontWeight="medium"
                    data-testid="first-column-label"
                  >
                    {firstColumnLabel}
                    <sup>2</sup>
                  </Typography>
                </div>
              </td>

              <td className="flex flex-col basis-1/3 flex-1 h-10 p-0">
                <div className="flex items-center justify-center content-center border-l-2 border-t-2 border-neutral-150 h-full leading-none">
                  <TooltipEstimatedDebtCost>
                    <Typography
                      className="text-[#5C708A] leading-none underline cursor-pointer"
                      variant="bodySm"
                      fontWeight="medium"
                      data-testid="last-column-label"
                    >
                      {lastColumnLabel}
                      <sup>3</sup>
                    </Typography>
                  </TooltipEstimatedDebtCost>
                </div>
              </td>
            </tr>
            <tr className="flex flex-row w-full text-center" data-testid="first-row">
              <th className="lg:border-t-2 lg:border-neutral-150 flex flex-col basis-1/3 flex-1 h-10 content-center justify-center lg:h-10 p-0">
                <div className="flex text-right items-center content-center justify-center lg:text-left">
                  <Typography
                    className="text-[#5C708A]"
                    variant="bodySm"
                    data-testid="first-row-label-one"
                  >
                    {labelFirstRow}
                  </Typography>
                </div>
              </th>
              <td className="flex flex-col basis-1/3 flex-1 h-10 content-center justify-center lg:h-10 p-0">
                <div className="border-l-2 border-t-2 border-neutral-150 h-full flex items-center justify-center content-center">
                  <Typography variant="bodySm" fontWeight="bold" data-testid="first-row-label-two">
                    {monthlyCurrent}
                  </Typography>
                </div>
              </td>
              <td className="flex flex-col basis-1/3 flex-1 h-10 content-center justify-center lg:h-10 p-0">
                <div className="border-l-2 border-t-2 border-neutral-150 h-full flex items-center justify-center content-center">
                  <Typography
                    variant="bodySm"
                    fontWeight="bold"
                    data-testid="first-row-label-three"
                  >
                    {totalCurrent}
                  </Typography>
                </div>
              </td>
            </tr>
            <tr
              className="flex flex-row w-full text-center bg-[#D2E2FE] border-b-2 border-neutral-150"
              data-testid="second-row"
            >
              <th className="flex flex-col basis-1/3 flex-1 h-10 content-center justify-center lg:h-10 lg:border-t-2 lg:border-neutral-150 p-0">
                <div className="flex text-right items-center content-center justify-center lg:text-left">
                  <AchieveLogo />
                </div>
              </th>
              <td className="flex flex-col basis-1/3 flex-1 h-10 content-center justify-center lg:h-10 p-0">
                <div className="border-l-2 border-t-2 border-neutral-150 h-full flex items-center justify-center content-center">
                  <Typography
                    className="text-[#3B6AF7]"
                    variant="bodySm"
                    fontWeight="bold"
                    data-testid="second-row-label-two"
                  >
                    {monthlyAchieve}
                  </Typography>
                </div>
              </td>
              <td className="flex flex-col basis-1/3 flex-1 h-10 content-center justify-center lg:h-10 p-0">
                <div className="border-l-2 border-t-2 border-neutral-150 h-full flex items-center justify-center content-center">
                  <Typography
                    variant="bodySm"
                    fontWeight="bold"
                    data-testid="second-row-label-three"
                  >
                    {totalAchieve}
                  </Typography>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}
